document.addEventListener('DOMContentLoaded', function() {
    const sliderContainer = document.querySelector('.section-packed__container');
    let swiperInstance = null; 

    function initializeOrDestroySwiper() {
      const isMobile = window.innerWidth <= 768;

      if (isMobile && sliderContainer && !swiperInstance) {
        swiperInstance = new Swiper(sliderContainer, {
        
          slidesPerView: 'auto',
          loop: true,
          spaceBetween: 15,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          watchOverflow: true, 
        });
      } else if (!isMobile && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    initializeOrDestroySwiper();
    window.addEventListener('resize', initializeOrDestroySwiper);
  });